var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRocket = function SvgRocket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    viewBox: "0 0 44 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#61697E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.75,
    d: "M7.333 23.833c3.27.389 6.313 1.866 8.64 4.194 2.328 2.327 3.805 5.37 4.194 8.64 1.62-.935 2.976-2.267 3.938-3.87.962-1.605 1.5-3.427 1.562-5.297 3.078-1.083 5.766-3.054 7.724-5.665 1.958-2.61 3.098-5.743 3.276-9.002 0-1.458-.58-2.857-1.611-3.889-1.032-1.031-2.43-1.61-3.89-1.61-3.258.177-6.39 1.317-9.001 3.275-2.61 1.958-4.582 4.646-5.665 7.724-1.87.062-3.692.6-5.296 1.562-1.604.962-2.936 2.318-3.87 3.938"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#61697E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.75,
    d: "M12.833 25.667c-1.908 1.077-3.45 2.7-4.43 4.66-.98 1.96-1.353 4.167-1.07 6.34 2.173.283 4.381-.09 6.34-1.07 1.96-.98 3.583-2.522 4.66-4.43M27.5 18.333c1.012 0 1.833-.82 1.833-1.833 0-1.012-.82-1.833-1.833-1.833-1.012 0-1.833.82-1.833 1.833 0 1.012.82 1.833 1.833 1.833z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRocket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rocket.7a0da4b3.svg";
export { ForwardRef as ReactComponent };